<template>
  <div class="container_box">
    <div class="bannerBg">
      <div class="box">
        <div class="title">
          <p>沃时派客</p>
          <p>让包装变得更简单</p>
        </div>
        <div class="text">
          <p>
            沃时派客数字化包装管理创新平台，通过海量的数据驱动
          </p>
          <p>
            运用智能化系统实现询价、方案定制、接单、生产、质检、物流等所有环节的数字化全覆盖
          </p>
        </div>
      </div>
    </div>
    <div class="platform">
      <div class="box">
        <div class="title">我们的平台</div>
        <p>沃时派客是国内领先的数字化包装管理创新平台，我们致力于通过互联网技术</p>
        <p>帮助企业供应链部门最大限度保证包装供应和包装总成本降低</p>
        <img src="@/assets/oursPlatform.png" alt="">
      </div>
      <div class="box2">
        <div>
          <div class="content">
            <div class="title">供应保证</div>
            <p>800+各类包装工厂汇聚平台，共同协同为企业服务</p>
            <p>MES（生产管理系统）链接企业和工厂，生产过程实时化</p>
            <p>TMS（物流管理系统）实时在途追踪物流运输</p>
            <p>QMS（质量管理系统）确保不同供应商达到相同质量要求</p>
          </div>
          <router-link class="btn" :to="{path: '/services', query: {anchorPoint: 'promise' }}">更多</router-link>
        </div>
        <div>
          <div class="content">
            <div class="title">TCO包装总成本降低</div>
            <p>沃时包装助手（小程序）</p>
            <p>提升各部门人效，可减少每年100万+的管理费用。</p>
            <p>数字化JIT和系统级API数据对接方案</p>
            <p>库存数据交互，可降低40%+的库存成本，甚至真正零库存</p>
          </div>
          <router-link class="btn" :to="{path: '/services', query: {anchorPoint: 'cost' }}">更多</router-link>

        </div>
      </div>
    </div>
    <div class="product">
      <div class="box">
        <div class="title">产品中心</div>
        <p>沃时数字化产品</p>
        <div class="tabs">
          <!-- @mouseenter -->
          <div class="tab" @click="active = 1">
            <img class="img" :src="active == 1 ? require('@/assets/product_icon/backstage_active.png') : require('@/assets/product_icon/backstage.png')">
            <div class="text" :style="{color:active == 1 ? '#3359cc':'#333' }">业务数据中台</div>
          </div>
          <div class="tab" @click="active = 2">
            <img class="img" :src="active == 2 ? require('@/assets/product_icon/weChat_client_active.png') : require('@/assets/product_icon/weChat_client.png')">
            <div class="text" :style="{color:active == 2 ? '#3359cc':'#333' }">沃时包装助手</div>
          </div>
          <div class="tab" @click="active = 3">
            <img class="img" :src="active == 3 ? require('@/assets/product_icon/weChat_supplier_active.png') : require('@/assets/product_icon/weChat_supplier.png')">
            <div class="text" :style="{color:active == 3 ? '#3359cc':'#333' }">沃时供应链助手</div>
          </div>
          <div class="tab" @click="active = 4">
            <img class="img" :src="active == 4 ? require('@/assets/product_icon/app_active.png') : require('@/assets/product_icon/app.png')">
            <div class="text" :style="{color:active == 4 ? '#3359cc':'#333' }">沃时货运助手</div>
          </div>
          <div class="tab" @click="active = 5">
            <img class="img" :src="active == 5 ? require('@/assets/product_icon/pad_active.png') : require('@/assets/product_icon/pad.png')">
            <div class="text" :style="{color:active == 5 ? '#3359cc':'#333' }">沃时云智造</div>
          </div>
        </div>
      </div>
      <div class="showBox">
        <transition name="fade">
          <div class="contentBox" v-if="active == 1">
            <div class="imgBox"><img class="img1" src="@/assets/home/backstage.png" alt=""></div>
            <div class="textBox">
              <div class="title">沃时数据中台</div>
              <p>致力于为包装供应链行业探索、验证，孵化和开发出包装供应链的创新产品+包装解决方案差异化定制，助力企业减少IT和管理的成本，实现数字化与产业链的加速融合，帮助产业链上下游实现数字化转型升级，为企业提供全方位高标准数字化服务体系</p>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="contentBox" v-if="active == 2">
            <div class="imgBox2"><img src="@/assets/home/weChat_client.png" alt=""></div>
            <div class="textBox">
              <div class="title">沃时包装助手</div>
              <p>助力企业搭建实时的数据分析包装供应链系统，已打通从询价到送货全过程，为客户提供了产品询价、产品报价、采购订单、打样订单、质检报告、预约送货、收货验货等功能。全链路协同协同增加效率，减少人工成本，提高企业运营效率</p>
            </div>
          </div>
        </transition>
        <transition name="fade">

          <div class="contentBox" v-if="active == 3">
            <div class="imgBox2"><img src="@/assets/home/weChat_supplier.png" alt=""></div>
            <div class="textBox">
              <div class="title">沃时供应链助手</div>
              <p>打通上下游企业在平台匹配更合适的交易，降低仓储、物流、损耗、原材料成本，实现企业间的协同，协助企业为客户提供高品质服务</p>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="contentBox" v-if="active == 4">
            <div class="imgBox2"><img src="@/assets/home/app.png" alt=""></div>
            <div class="textBox">
              <div class="title">沃时货运助手</div>
              <p>司机端APP将货物的配送环节融入供应链管理的各个环节，并成为包装供应链管控的重要一环。结合司机端APP，客户、供应商和沃时可实时掌握物流运送信息，司机同时可成为从发货到收货全过程中的沟通保障</p>
            </div>
          </div>
        </transition>
        <transition name="fade">

          <div class="contentBox" v-if="active == 5">
            <div class="imgBox"><img class="img1" src="@/assets/home/pad.png" alt=""></div>
            <div class="textBox">
              <div class="title">沃时云智造</div>
              <p>自主研发沃时云制造（MES系统）和沃时货运助手（TMS系统），打通了企业与生产工厂间的信息孤岛，过程数据更实时化，同时掌握生产、库存和物流信息，提升企业间供需要求反应速度。以确保在供应链风险加剧的情况下，仍能满足企业对于供应保障的需求</p>
            </div>
          </div>
        </transition>

      </div>
    </div>
    <!-- <router-link to="/services#service1"><div class="row"><img :src="$t('imgPath.home1')" /></div></router-link>
    <router-link to="/services#service2"><div class="row"><img :src="$t('imgPath.home2')" /></div></router-link>
    <router-link to="/services#service3"><div class="row"><img :src="$t('imgPath.home3')" /></div></router-link> -->
    <!-- <div ref="header" class="animate__animated" :class="{'animate__bounceInLeft':header_Animate}">
      测试测试测试
    </div> -->
    <!-- <li class="wow slideInUp">asdfasdfasdfasdfasdfasdfaaaaaaaa</li> -->
  </div>
</template>

<script>

// import { isElementNotInViewport} from "@/utils/initElementSensor.js";
// https://blog.csdn.net/Kavii_a/article/details/111734274
export default {
  data() {
    return {
      // header_Animate: false
      active: 1,
    };
  },
  mounted() {
    // new this.$wow.WOW().init()
    // 监听滚动事件
    // window.addEventListener("scroll", this.scrollToTop);
  },
  // beforeRouteLeave(to, form, next) {
  //   // 离开路由移除滚动事件
  //   window.removeEventListener('scroll',this.scrollToTop);
  //   next();
  // },
  methods: {
    // scrollToTop() {
    //   !isElementNotInViewport(this.$refs.header) ? this.header_Animate = true: '';
    // }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.bannerBg {
  background-image: url("../../../assets/banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 788px;
  font-weight: 400;
  color: #fff;
  .box {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      width: 1200px;
      margin-top: 235px;
      font-size: 60px;
    }
    .text {
      width: 1200px;
      margin-top: 44px;
      font-size: 18px;
      line-height: 27px;
    }
  }
}
.platform {
  display: flex;
  flex-direction: column;
  align-items: center;
  .box {
    width: 1200px;
    text-align: center;
    .title {
      margin: 100px 0 24px 0;
      font-size: 42px;
    }
    p {
      font-size: 16px;
      line-height: 24px;
      color: #999999;
    }
    img {
      width: 655px;
      height: 321px;
    }
  }
  .box2 {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    .title {
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 24px;
    }
    p {
      color: #666666;
      font-size: 14px;
      line-height: 30px;
    }
    .content {
      margin-bottom: 24px;
    }
    .btn {
      border-radius: 28px;
      padding: 10px 40px;
      font-size: 16px;
      background-color: #3359cc;
      border-color: #3359cc;
      color: #fff;
    }
    .btn:hover {
      background-color: #486ad0;
      border-color: #486ad0;
    }
  }
}
.product {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 89px;
  .box {
    width: 1200px;
    text-align: center;
    .title {
      font-size: 42px;
      line-height: 49px;
      text-align: center;
      margin-bottom: 24px;
    }
    p {
      color: #999999;
      font-size: 16px;
    }
    .tabs {
      display: flex;
      flex-direction: initial;
      justify-content: space-around;
      margin-top: 48px;
      .tab {
        padding: 10px;
        cursor: pointer;
      }
      .tab:hover {
        // box-shadow: 0 0 10px #eee;
        // border-radius: 20px;
        .text {
          color: #3359cc !important;
        }
      }

      .img {
        width: 90px;
        height: 90px;
      }
      .text {
        margin-top: 26px;
        font-size: 18px;
        color: #333;
        cursor: pointer;
      }
    }
  }
  .showBox {
    background-color: #f7f8fb;
    height: 576px;
    width: 100%;
    margin-top: 52px;
    display: flex;
    // align-items: center;
    justify-content: center;
    .contentBox {
      position: absolute;
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 576px;
      .imgBox {
        width: 566px;
        height: 319px;
      }
      .imgBox2 {
        width: 685px;
        height: 470px;
      }
      .img1 {
        box-shadow: 5px 6px 23px 1px rgba(62, 67, 104, 0.20000000298023224);
        border-radius: 26px;
        border-radius: 12px;
      }
      .textBox {
        margin-top: -50px;
        width: 441px;
        .title {
          font-size: 24px;
          margin-bottom: 20px;
        }
        p {
          color: #666666;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
}

// @keyframes fade-in {
//     0% {opacity: 0;}/*初始状态 透明度为0*/
//     40% {opacity: 0;}/*过渡状态 透明度为0*/
//     100% {opacity: 1;background-color: aqua;}/*结束状态 透明度为1*/
// }
// @-webkit-keyframes fade-in {/*针对webkit内核*/
//     0% {opacity: 0;}
//     40% {opacity: 0;}
//     100% {opacity: 1;background-color: aqua;}
// }
// .animated {
//     animation: fade-in;/*动画名称*/
//     animation-duration: 1.5s;/*动画持续时间*/
//     -webkit-animation:fade-in 1.5s;/*针对webkit内核*/
// }
/* https://v3.cn.vuejs.org/guide/transitions-enterleave.html#过渡class
v-enter-from  开始状态
v-enter-active  进入过渡生效时的状态
v-enter-to  进入过渡的结束状态
v-leave-from 离开过渡的开始状态
v-leave-active 离开过渡生效时的状态
v-leave-to 离开过渡的结束状态 */

.fade-enter-from {
  // transition: left 1s ease-in;
  left: 1000px;
}
.fade-enter-active {
  transition: left 0.3s ease-in;
  left: 800px;
}
.fade-enter-to {
  transition: left 0.3s ease-in;
  left: 450px;
}
.fade-leave-from {
  // transition: left 1s ease-out;
  left: 450px;
}
.fade-leave-active {
  transition: left 0.3s ease-out;
  left: -800px;
}
.fade-leave-to {
  transition: left 0.3s ease-out;
  left: -1500px;
}

// .fade-enter-active,
// .fade-leave-active {
//   // transition: opacity 1s ease-in;
//   transition: left 1s ease;
//   left:0;
// }

// .fade-enter-from,
// .fade-leave-to {
//   // opacity: 0 1s ease-in;
//   left: -1500px;
// }

// .fadeOut-enter-active,
// .fadeOut-leave-active {
//   // transition: opacity 1s ease-in;
//   transition: left 1s ease;
//   left:0;
// }

// .fadeOut-enter-from,
// .fadeOut-leave-to {
//   // opacity: 0 1s ease-in;
//   left: -1500px;
// }
</style>
